import * as i0 from '@angular/core';
import { Injectable, ViewChild, Output } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import { pluck, mergeMap, concatMap, delay, takeLast, tap } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import * as i1 from '@angular/common/http';
import * as errorUtils from 'error-message-utility';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { acceptedFileTypes } from 'app-models';
import { getStepDetails, updateStepStatus, updateStepStatusToInitialState } from 'visa-store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { environment } from 'environment-configurations';
import { from } from 'rxjs';
import * as i6 from '@angular/forms';
import { Validators, FormControl } from '@angular/forms';
import { CustomErrorToastComponent } from 'custom-error-toast';
import * as i3 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from '@angular/material/dialog';

class APIPrintPetition {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    postReviewPetitiondocDraft(visatype, caseType, caseId, draft) {
        return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/generate/${draft}/fullpdf`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getReviewPetitiondocDraft(visatype, caseType, caseId, draft) {
        return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/generate/${draft}/fullpdf`).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    getI140ReviewComments(visatype, caseType, caseId) {
        return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/review`).pipe(map((response) => {
            if (response && (response.status === 200 || response.status === 204)) {
                return response;
            }
        }));
    }
    getDocumentDetails(taskStepId) {
        return this.httpClient.get(`/signature/getDocuments/${taskStepId}`).pipe(map((response) => {
            if (response && (response.status === 200 || response.status === 204)) {
                return response;
            }
        }));
    }
    getsignatureDetails(taskID) {
        return this.httpClient.get(`/signature/availability/${taskID}`).pipe(map((response) => {
            if (response && (response.status === 200 || response.status === 204)) {
                return response;
            }
        }));
    }
    postsignatureDetails(taskID, payload) {
        return this.httpClient.post(`/signature/notification/${taskID}`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getEmailTemplateList(payload) {
        return this.httpClient.post("/emailTemplates/list/EMALTEMPLT", payload).pipe(pluck('data'), map((codes) => {
            return codes;
        }));
    }
    getSignatureTypeList(data) {
        return this.httpClient.get(`/referenceLibrary/${data}`).pipe(map((response) => {
            return response;
        }));
    }
    postSendsignature(payload) {
        return this.httpClient.post(`/signature/sendMail`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getEmailTemplateById(emailTemplateId) {
        return this.httpClient.get(`/emailTemplates/${emailTemplateId}`).pipe(map((response) => {
            if (response.status == 200) {
                return response.data;
            }
            else {
                return null;
            }
        }));
    }
    postCourier(type, payload) {
        return this.httpClient.post(`/signature/updateCourierStatus/${type}`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    postFormType(visatype, caseType, caseId, superTaskId, taskId, formType, payload) {
        var _a, _b;
        let tempUrl;
        if (sessionStorage.getItem('signatureUpload')) {
            let usedInSendFormSign = '';
            if ((_a = payload === null || payload === void 0 ? void 0 : payload.signatories) === null || _a === void 0 ? void 0 : _a.attorney) {
                usedInSendFormSign += `&usedInSendFormSignForAttorney=true`;
            }
            if ((_b = payload === null || payload === void 0 ? void 0 : payload.signatories) === null || _b === void 0 ? void 0 : _b.petitioner) {
                usedInSendFormSign += `&usedInSendFormSignForPetitioner=true`;
            }
            tempUrl = `/${visatype}/${caseType}/${caseId}/form/${formType}/generate?superTaskId=${superTaskId}&taskId=${taskId}${usedInSendFormSign}`;
        }
        else {
            tempUrl = `/${visatype}/${caseType}/${caseId}/form/${formType}/generate?superTaskId=${superTaskId}&taskId=${taskId}`;
        }
        return this.httpClient.post(tempUrl, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getDependentFormInfo(visatype, caseType, caseId) {
        return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/formInfo`).pipe(map((response) => {
            return response;
        }));
    }
    postDependentFormType(visatype, caseType, caseId, taskId, formType, payload) {
        var _a, _b;
        let tempUrl;
        if (sessionStorage.getItem('signatureUpload')) {
            let usedInSendFormSign = '';
            if ((_a = payload === null || payload === void 0 ? void 0 : payload.signatories) === null || _a === void 0 ? void 0 : _a.attorney) {
                usedInSendFormSign += `&usedInSendFormSignForAttorney=true`;
            }
            if ((_b = payload === null || payload === void 0 ? void 0 : payload.signatories) === null || _b === void 0 ? void 0 : _b.petitioner) {
                usedInSendFormSign += `&usedInSendFormSignForPetitioner=true`;
            }
            tempUrl = `/${visatype}/${caseType}/${caseId}/form/${formType}/generateGenericForms?taskId=${taskId}${usedInSendFormSign}`;
        }
        else {
            tempUrl = `/${visatype}/${caseType}/${caseId}/form/${formType}/generateGenericForms?taskId=${taskId}`;
        }
        return this.httpClient.post(tempUrl, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    generatePDF(visaType, caseType, caseId, letterType, payload) {
        return this.httpClient.post(`/${visaType}/${caseType}/${caseId}/letter/${letterType}/generate/pdf`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    generateI140PDF(superTaskId, caseId, letterType, payload) {
        return this.httpClient.post(`/task/${superTaskId}/case/${caseId}/letter/${letterType}/generate/pdf`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getPreview(visaType, caseType, caseId, letterType, superTaskId, taskId, isBackEnabled, payload) {
        const backEnabledFlag = isBackEnabled ? '&isBackEnabled=true' : '';
        let tempUrl;
        if (sessionStorage.getItem('signatureUpload')) {
            tempUrl = `/${visaType}/${caseType}/${caseId}/letter/${letterType}/preview?superTaskId=${superTaskId}&taskId=${taskId}${backEnabledFlag}&usedInSendFormSign=true`;
        }
        else {
            tempUrl = `/${visaType}/${caseType}/${caseId}/letter/${letterType}/preview?superTaskId=${superTaskId}&taskId=${taskId}${backEnabledFlag}`;
        }
        return this.httpClient.post(tempUrl, payload).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    getI140Preview(superTaskId, caseId, letterType, payload) {
        let tempUrl;
        if (sessionStorage.getItem('signatureUpload')) {
            tempUrl = `/task/${superTaskId}/case/${caseId}/letter/${letterType}/preview&usedInSendFormSign=true`;
        }
        else {
            tempUrl = `/task/${superTaskId}/case/${caseId}/letter/${letterType}/preview`;
        }
        return this.httpClient.post(tempUrl, payload).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    deleteTemplateInfo(visaType, caseType, caseId, letterType, superTaskId, taskId) {
        return this.httpClient.delete(`/${visaType}/${caseType}/${caseId}/additionalInfo/${letterType}?superTaskId=${superTaskId}&taskId=${taskId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    uploadDocument(pbSupportingId, payload, signId, formType) {
        return this.httpClient.post(`/signature/uploadFile/${pbSupportingId}/${signId}?type=${formType}`, payload).pipe(map((response) => response));
    }
    downloadDocuments(path, fileName) {
        return this.httpClient.get(path, { responseType: "arraybuffer" }).subscribe(pdf => {
            var blob = new Blob([pdf], { type: 'application/pdf' });
            saveAs(blob, fileName);
        });
    }
    sendNotification(signDetailsId, payload) {
        return this.httpClient.post(`/signature/generateNotification/${signDetailsId}`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getEmailTemplateByIdBenId(emailTemplateId, taskId) {
        let companyId = sessionStorage.getItem('companyId');
        return this.httpClient.get(`/emailTemplates/emailTemplateId/${emailTemplateId}?petitionerId=${companyId}&taskId=${taskId}`).pipe(map((response) => {
            if (response.status == 200) {
                return response.data;
            }
            else {
                return null;
            }
        }));
    }
}
APIPrintPetition.ɵfac = function APIPrintPetition_Factory(t) { return new (t || APIPrintPetition)(i0.ɵɵinject(i1.HttpClient)); };
APIPrintPetition.ɵprov = i0.ɵɵdefineInjectable({ token: APIPrintPetition, factory: APIPrintPetition.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APIPrintPetition, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class BasePrintPetitionLibraryService {
    constructor(store, apiService, toastr, stepStatusUpdatePayloadCostruction, dialog, fb) {
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.dialog = dialog;
        this.fb = fb;
        this.observableSubscription$ = new Subject();
        this.signatureType = '';
        this.returnForms = '';
        this.displayDialog = false;
        this.displayCourier = false;
        this.signatureInfo = [];
        this.selectedSignatory = [];
        this.isMailSent = false;
        this.signatureChecked = false;
        this.tempCheck = false;
        this.checkedList = [];
        this.templateList = [];
        this.displayedColumns = ['formType', 'docUploaded', 'actions'];
        this.dataSource = [];
        this.isMenuVisible = false;
        this.currentItem = null;
        this.dependentFormInfo = {};
        this.selectable = true;
        this.removable = true;
        this.emailPattern = '^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6})(\\s*,\\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6})*$';
        this.acceptedTypes = acceptedFileTypes;
        this.maxfileSizeInMB = 10;
        this.uploadCount = 0;
        this.signatureInfoAvailable = false;
        this.currentSelect = false;
        this.placeholderErrorDialog = false;
        this.formDataArray = {
            common: [],
            primary: [],
            secondary: []
        };
        this.masterSelected = false;
        this.draftGeneratedDate = '';
        this.fullPDFPath = '';
        this.disabledControls = false;
    }
    loadInit() {
        document.addEventListener('click', this.onDocumentClick.bind(this));
        this.getSignatureTypeList();
        // this.getDocumentDetailsList();
        this.onLoadSignature();
        this.getTemplateList();
        this.courierStatusForm = this.fb.group({
            courierStatus: [null, Validators.required],
        });
        this.initdefinedTemplateform();
        this.definedtemplate.controls['addForms'].setValue([1, 2]);
        this.onChangeSignature('Signature1');
        this.getDependentFormInfo();
        if (sessionStorage.getItem('wizardTID')) { //when Wizard is there
            // this.toggleControlsStatus();
            this.getGenernatedPetition(false);
        }
        else {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId }))
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((data) => {
                this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 || data.isBeneficiaryAction === 1 ? 'MARK_COMPLETE' : 'MARK_SUBMIT';
                this.stepDetails = data;
                // if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
                //   this.updateStepStatus('INPROGRESS');
                // }
                this.toggleControlsStatus();
                this.getGenernatedPetition(false);
            });
        }
    }
    onDocumentClick() {
        this.isMenuVisible = false; // Hide the menu
        this.currentItem = null; // Reset the current item
    }
    getSignatureTypeList() {
        this.apiService.getSignatureTypeList('SIGNTYP').subscribe(data => {
            if (data) {
                this.signatureTypeList = data === null || data === void 0 ? void 0 : data.data;
                this.signatureTypeList.map(x => {
                    x.signatureType = x.code;
                    x.id = x.code == "IMAGE" ? 'Signature1' : 'Signature2';
                });
            }
        });
    }
    getTemplateList() {
        const payload = {
            "superTaskTypeId": "EMALTEMPLT",
            "isDefault": "false",
            "pageNumber": 1,
            "recordsPerPage": 100,
            "searchText": ""
        };
        this.apiService.getEmailTemplateList(payload).subscribe(data => {
            data['documentTemplate'].forEach(element => {
                element.documentType = element.documentType.code;
                element.templateType = element.templateType.code;
                this.templateList.push(element);
            });
        });
    }
    getDocumentDetails() {
        this.apiService.getDocumentDetails(this.inputData.stepId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            var _a;
            this.isMailSent = ((_a = response.data) === null || _a === void 0 ? void 0 : _a.signatureDetailId) ? true : false;
            if (response && response.data && response.data.signatureDocumentDTOList.length > 0) {
                this.signatureDetailId = response.data.signatureDetailId;
                this.listDocuments = response.data.signatureDocumentDTOList;
                this.listDocuments.map(item => {
                    let signatureList = [];
                    item.isSelected = false;
                    if (item === null || item === void 0 ? void 0 : item.signatories) {
                        item === null || item === void 0 ? void 0 : item.signatories.forEach(element => {
                            if (element.checked) {
                                if (item.signatories.length == 1) {
                                    signatureList.push(element.label);
                                }
                                else if (item.signatories[item.signatories.length - 1]) {
                                    signatureList.push(element.label);
                                }
                                else {
                                    signatureList.push(element.label + ',');
                                }
                            }
                        });
                        item.signatorList = signatureList;
                    }
                });
            }
            else {
                this.listDocuments = [];
            }
        });
    }
    onTemplateChange(event) {
        this.apiService.getEmailTemplateByIdBenId(event, this.inputData.subTaskId).subscribe(data => {
            var _a;
            if (data) {
                this.definedtemplate.controls['emailbody'].setValue(data.contentMap.body + '<br>' + ((_a = data.contentMap) === null || _a === void 0 ? void 0 : _a.footer));
                this.definedtemplate.controls['subject'].setValue(data.contentMap.header);
            }
            var split = this.definedtemplate.controls['emailbody'].value.split("<p>");
            for (var i = 0; i < split.length; i++) {
                if (split[i].includes('${')) {
                    split[i] = "<p style='color:red'>" + split[i];
                }
                else {
                    split[i] = "<p>" + split[i];
                }
            }
            this.definedtemplate.controls['emailbody'].setValue(split.join(''));
        });
    }
    generatePetition(isDraft = false) {
        this.apiService.postReviewPetitiondocDraft(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, isDraft)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.data) {
                this.enableViewDraftButton = response.data.isExist;
                this.draftGeneratedDate = response.data.lastModifiedTime;
                this.fullPDFPath = response.data.path;
                this.toastr.success(response.message, 'Success');
            }
        });
    }
    getGenernatedPetition(isDraft = false) {
        this.apiService.getReviewPetitiondocDraft(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, isDraft)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.status === 200) {
                this.enableViewDraftButton = response.data.isExist;
                this.draftGeneratedDate = response.data.lastModifiedTime;
                this.fullPDFPath = response.data.path;
            }
        });
    }
    updateStepStatus(status) {
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
            subTaskId: this.stepDetails.taskId,
            visaType: this.inputData.caseType === 'I130' ?
                this.inputData.caseType : this.inputData.visatype,
            stepId: this.inputData.stepId
        }));
    }
    viewPetition(fullPDFPath) {
        window.open(`${environment.docs}${fullPDFPath.substring(23)}`);
    }
    //Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls =
            this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" ||
                this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" ||
                this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT";
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    onChangeSignature(type) {
        this.signatureType = type;
        this.onLoadSignature();
        this.checkedList = [];
        this.formsList = [];
        this.displayForms = [];
        this.definedtemplate.reset();
        this.initdefinedTemplateform();
        if (!type) {
            this.onReturnForms(null);
        }
        else {
            this.onReturnForms('type3');
        }
    }
    onLoadSignature() {
        this.apiService.getsignatureDetails(this.inputData.subTaskId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response === null || response === void 0 ? void 0 : response.data) {
                this.signatureInfo = response.data;
                this.selectedSignatory = response.data;
                if (this.signatureInfo.find(item => item.signatureAvalible === true)) {
                    this.signatureInfoAvailable = true;
                }
                // Create form controls for `additionalCoversForm`
                const additionalCoversControls = this.signatureInfo.reduce((controls, cover, index) => {
                    controls[index] = new FormControl(cover.checked); // Default value for each checkbox
                    return controls;
                }, {});
                this.additionalCoversForm = this.fb.group(additionalCoversControls);
                // Create form controls for `signatoriesSignedForm`
                const signatoriesControls = this.selectedSignatory.reduce((controls, cover, index) => {
                    controls[index] = new FormControl(cover.checked); // Default value for each checkbox
                    return controls;
                }, {});
                this.signatoriesSignedForm = this.fb.group(signatoriesControls);
            }
        });
    }
    onReturnForms(type) {
        this.masterSelected = false;
        if (type == 'type3' || type == 'type4') {
            this.returnForms = type;
        }
        this.checkedList = [];
        this.formsList = [];
        this.displayForms = [];
        this.definedtemplate.reset();
        this.getDocumentDetails();
        this.initdefinedTemplateform();
    }
    onChangeCourier(type) {
        this.courierStatusForm.controls['courierStatus'].setValue(type);
    }
    checkUncheckAll() {
        for (var i = 0; i < this.listDocuments.length; i++) {
            this.listDocuments[i].isSelected = this.masterSelected;
        }
        this.getCheckedItemList();
    }
    isAllSelected() {
        this.masterSelected = this.listDocuments.every(function (item) {
            return item.isSelected == true;
        });
        this.getCheckedItemList();
    }
    getCheckedItemList() {
        this.checkedList = [];
        for (var i = 0; i < this.listDocuments.length; i++) {
            if (this.listDocuments[i].isSelected)
                this.checkedList.push(this.listDocuments[i]);
        }
    }
    onClickEmail() {
        this.commonMail();
        this.filterItems();
    }
    filterItems() {
        const filteredItems = this.checkedList.filter((item) => this.formsList.some((firstItem) => firstItem.pbSupportDocumentId === item.pbSupportDocumentId));
        let newArray = [];
        newArray = filteredItems.map(item => item.pbSupportDocumentId);
        this.definedtemplate.controls['addForms'].setValue(newArray);
        this.displayForms = [];
        this.displayForms = this.checkedList;
    }
    commonMail() {
        this.definedtemplate.reset();
        this.initdefinedTemplateform();
        this.formsList = this.listDocuments;
        const selectedEmail = this.selectedSignatory.filter(item => item.checked && item.mail)
            .map(item => item.mail);
        this.definedtemplate.controls['toEmailids'].setValue(selectedEmail);
        this.definedtemplate.controls['fromEmailids'].setValue(['communication@imagility.co']);
        this.displayDialog = true;
    }
    onIndividualMail(item) {
        this.commonMail();
        this.filterIndividualItems(item);
    }
    filterIndividualItems(item) {
        const filteredItems = [item].filter((x) => this.formsList.some((firstItem) => firstItem.pbSupportDocumentId === x.pbSupportDocumentId));
        let newArray = [];
        newArray = filteredItems.map(item => item.pbSupportDocumentId);
        this.definedtemplate.controls['addForms'].setValue(newArray);
        this.displayForms = [];
        this.displayForms = [item];
    }
    handleNo() {
        this.displayDialog = false;
    }
    initdefinedTemplateform() {
        this.definedtemplate = this.fb.group({
            templatename: [''],
            fromEmailids: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
            toEmailids: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
            ccEmailids: ['', Validators.pattern(this.emailPattern)],
            subject: ['', Validators.required],
            addForms: ['', Validators.required],
            emailbody: ['']
        });
    }
    createtemplatelibraryheaderValueChange(value) {
        // this.template.header = value;
    }
    createtemplatelibraryheaderimageuploaddialog() {
        this.createtemplatelibraryheaderupload.open();
    }
    remove(pbSupportDocumentId) {
        const itemIndex = this.formsList.findIndex(form => form.pbSupportDocumentId === pbSupportDocumentId);
        if (itemIndex !== -1) {
            const currentValue = this.definedtemplate.controls['addForms'].value;
            this.definedtemplate.controls['addForms'].setValue(currentValue.filter((formId) => formId !== pbSupportDocumentId));
            this.displayForms = this.displayForms.filter(form => form.pbSupportDocumentId !== pbSupportDocumentId);
        }
    }
    onChangeForms(code) {
        this.displayForms = [];
        this.displayForms = this.formsList.filter(item => code === null || code === void 0 ? void 0 : code.value.includes(item.pbSupportDocumentId));
    }
    onSubmit() {
        if (this.definedtemplate.controls['emailbody'].value.includes('${')) {
            this.placeholderErrorDialog = true;
            var split = this.definedtemplate.controls['emailbody'].value.split("<p>");
            for (var i = 0; i < split.length; i++) {
                if (split[i].includes('${')) {
                    split[i] = "<p style='color:red'>" + split[i];
                }
                else {
                    split[i] = "<p>" + split[i];
                }
            }
            // this.definedtemplate.controls['emailbody'].value = split.join('');
            this.definedtemplate.controls['emailbody'].setValue(split.join(''));
            return false;
        }
        if (this.definedtemplate.valid) {
            const signatureData = {
                "emailBody": this.definedtemplate.controls['emailbody'].value,
                "emailCCList": this.definedtemplate.controls['ccEmailids'].value ? this.definedtemplate.controls['ccEmailids'].value : [],
                "emailSubject": this.definedtemplate.controls['subject'].value,
                "emailToList": this.definedtemplate.controls['toEmailids'].value,
                "signatureDocumentDTOList": this.displayForms,
                "taskId": this.inputData.subTaskId,
                "taskStepId": this.inputData.stepId,
                "type": this.returnForms == 'type3' ? 'DLVRSRVC' : 'SIGNUPLOADFORM',
                "signatureType": this.signatureType === 'Signature1' ? 'IMAGE' : 'MANUAL',
                "signatories": this.signatureInfo.filter(item => item.checked === true)
            };
            this.apiService.postSendsignature(signatureData).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                if (response && response.status == 200) {
                    this.toastr.success(response.message, 'Success');
                    this.displayDialog = false;
                    this.onLoadSignature();
                    // this.getDocumentDetailsList();
                    this.onReturnForms(this.returnForms);
                }
            });
        }
    }
    onChangeCourierStatus() {
        if (this.courierStatusForm.valid) {
            this.apiService.postCourier(this.courierStatusForm.controls['courierStatus'].value, this.selectedCourierArr).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                if (response && response.status == 200) {
                    this.toastr.success(response.message, 'Success');
                    this.displayCourier = false;
                    this.onReturnForms(this.returnForms);
                }
            });
        }
    }
    onClickCourier(val, id) {
        this.displayCourier = true;
        this.selectedCourierArr = [];
        if (id == 1 && val) {
            this.selectedCourierArr = [val];
        }
        else {
            this.selectedCourierArr = this.checkedList.map(item => item.id);
        }
    }
    onClickCloseCourier() {
        this.displayCourier = false;
    }
    toggleVisibility(event, item) {
        this.signatureInfo[item].checked = event.target.checked;
        this.signatureInfo.filter(x => x.signatureAvalible).map(y => {
            if (y.checked) {
                this.currentSelect = true;
            }
        });
        this.currentSelect = this.signatureInfo.find(x => x.signatureAvalible && x.checked);
        this.signatureInfo.filter(x => !x.signatureAvalible).map(y => {
            if (y.checked) {
                this.currentSelect = false;
            }
        });
    }
    toggleSignatoryVisibility(event, item) {
        this.selectedSignatory[item].checked = event.target.checked;
    }
    onSignatureSubmit() {
        if (this.signatureInfo.find(item => item.checked === true) && this.checkedList.length !== 0) {
            const payload = {
                signatories: this.signatureInfo,
                signatureDocumentDTOList: this.checkedList,
                signatureNotificationDTO: this.signatureInfo,
                signatureType: "IMAGE",
                taskId: this.inputData.subTaskId,
                taskStepId: this.inputData.stepId,
                type: null,
                usedInImage: true
            };
            this.apiService.postsignatureDetails(this.inputData.subTaskId, payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                if (response && response.status == 200) {
                    this.toastr.success(response.message, 'Success');
                    this.onLoadSignature();
                    this.onReturnForms(this.returnForms);
                }
            });
        }
        else {
            CustomErrorToastComponent.showErrorToast(this.toastr, 'Please select the Signatories & forms from below section');
        }
    }
    onClickGenerateForm(pbSupportDocumentId) {
        this.individualForm = [];
        if (pbSupportDocumentId) {
            this.individualForm.push(this.listDocuments.find(item => pbSupportDocumentId == item.pbSupportDocumentId));
            this.postGenerateDoc(this.individualForm, 1);
        }
    }
    postGenerateDoc(currentItem, data) {
        let apiCalls = []; // Array to hold all API call observables
        currentItem.forEach(immCategory => {
            var _a, _b, _c, _d, _e, _f;
            if (immCategory.formCode === 'I129' && this.inputData.taskTypeSaveJsonId && !['H3B', 'H3A', 'E3'].includes(this.inputData.getTaskType)) {
                const dependentCall = this.postDependentGenerateDocObservable(immCategory.formCode, 0, 'false', null, immCategory);
                if (dependentCall)
                    apiCalls.push(dependentCall);
            }
            else if (immCategory.formCode === 'COVLTR' || immCategory.formCode === 'SUPLTR') {
                let tempTemplateId = immCategory.formCode === 'COVLTR'
                    ? (_a = immCategory.petitionTemplateInfo) === null || _a === void 0 ? void 0 : _a.coverLetterTemplateId : (_b = immCategory.petitionTemplateInfo) === null || _b === void 0 ? void 0 : _b.supportLetterTemplateId;
                const apiCall = this.inputData.caseType === 'I140'
                    ? this.apiService.getI140Preview(this.inputData.superTaskId, this.inputData.caseId, immCategory.formCode, { templateId: tempTemplateId })
                        .pipe(mergeMap(() => this.generatePDF(immCategory.formCode, tempTemplateId)))
                    : this.apiService.getPreview(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, immCategory.formCode, this.inputData.superTaskId, this.inputData.subTaskId, true, { templateId: tempTemplateId })
                        .pipe(mergeMap(() => this.generatePDF(immCategory.formCode, tempTemplateId)));
                apiCalls.push(apiCall);
            }
            else {
                let payload = {};
                if (['I129', 'G28', 'I907', 'G1145', 'G1450'].includes(immCategory.formCode)) {
                    payload = { formType: immCategory.formCode, signatories: { attorney: false, petitioner: false } };
                    const iAttorney = (_c = this.signatureInfo) === null || _c === void 0 ? void 0 : _c.findIndex(e => e.label === 'Attorney' && e.checked);
                    const iPetitioner = (_d = this.signatureInfo) === null || _d === void 0 ? void 0 : _d.findIndex(e => e.label === 'Petitioner' && e.checked);
                    if (iAttorney > -1 || ((_e = immCategory === null || immCategory === void 0 ? void 0 : immCategory.signatorList) === null || _e === void 0 ? void 0 : _e.includes('Attorney'))) {
                        payload.signatories.attorney = true;
                    }
                    if (iPetitioner > -1 || ((_f = immCategory === null || immCategory === void 0 ? void 0 : immCategory.signatorList) === null || _f === void 0 ? void 0 : _f.includes('Petitioner'))) {
                        payload.signatories.petitioner = true;
                    }
                    apiCalls.push(this.apiService.postFormType(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.inputData.superTaskId, this.inputData.subTaskId, immCategory.formCode, payload));
                }
                else {
                    const dependentTempCall = this.postDependentGenerateDocObservable(immCategory.formCode, 0, 'false', null, immCategory);
                    if (dependentTempCall)
                        apiCalls.push(dependentTempCall);
                }
            }
        });
        // Execute API calls sequentially using concatMap
        if (apiCalls.length > 0) {
            from(apiCalls)
                .pipe(concatMap(apiCall => apiCall.pipe(delay(100))), // Ensures sequential execution
            takeLast(1) // Ensures we show success after all API calls complete
            )
                .subscribe({
                next: () => {
                    this.toastr.success('Forms Generated Successfully!', "Success");
                    this.getNotification(data);
                },
                error: err => {
                    console.error('Error in API calls:', err);
                }
            });
        }
    }
    getNotification(data) {
        if (data !== 1) {
            if (this.checkedList.filter(x => x.id !== null).length !== 0) {
                this.apiService.sendNotification(this.signatureDetailId, this.checkedList.filter(x => x.id !== null).map(y => y.id)).subscribe(res => {
                    if (res) {
                        this.getDocumentsList();
                    }
                });
            }
            else {
                this.getDocumentsList();
            }
        }
        else {
            if (this.individualForm[0].id) {
                this.apiService.sendNotification(this.signatureDetailId, [this.individualForm[0].id]).subscribe(res => {
                    if (res) {
                        this.getDocumentsList();
                    }
                });
            }
            else {
                this.getDocumentsList();
            }
        }
    }
    getDocumentsList() {
        this.checkedList = [];
        this.masterSelected = false;
        this.getDocumentDetails();
    }
    postDependentGenerateDocObservable(formType, id, generateAll, relationshipCode, immCategory = {}) {
        var _a, _b, _c, _d, _e;
        const applicantList = [];
        if (generateAll === 'true' || (this.inputData.visatype === 'ASYLUM' && this.inputData.immigrationClassification !== 'ASYLRELATIVE' && ((_a = this.dependentFormInfo.applicantList) === null || _a === void 0 ? void 0 : _a.length) > 0)) {
            const secondaryApplicants = this.dependentFormInfo.applicantList.filter(item => !item.primaryApplicant);
            applicantList.push(...secondaryApplicants.map(({ id }) => id));
        }
        else if (id && relationshipCode) {
            applicantList.push(id);
        }
        const payload = {
            applicantList,
            generateAll: generateAll === 'true' ? true : false,
            signatories: { attorney: false, petitioner: false }
        };
        const iAttorney = (_b = this.signatureInfo) === null || _b === void 0 ? void 0 : _b.findIndex(e => e.label === 'Attorney' && e.checked);
        const iPetitioner = (_c = this.signatureInfo) === null || _c === void 0 ? void 0 : _c.findIndex(e => e.label === 'Petitioner' && e.checked);
        if (iAttorney > -1 || ((_d = immCategory === null || immCategory === void 0 ? void 0 : immCategory.signatorList) === null || _d === void 0 ? void 0 : _d.includes('Attorney'))) {
            payload.signatories.attorney = true;
        }
        if (iPetitioner > -1 || ((_e = immCategory === null || immCategory === void 0 ? void 0 : immCategory.signatorList) === null || _e === void 0 ? void 0 : _e.includes('Petitioner'))) {
            payload.signatories.petitioner = true;
        }
        return this.apiService.postDependentFormType(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.inputData.subTaskId, formType, payload);
    }
    generatePDF(formCode, tempTemplateId) {
        const pdfObservable = this.inputData.caseType === 'I140'
            ? this.apiService.generateI140PDF(this.inputData.superTaskId, this.inputData.caseId, formCode, { templateId: tempTemplateId })
            : this.apiService.generatePDF(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, formCode, { templateId: tempTemplateId });
        return pdfObservable.pipe(tap(() => console.log('PDF Generated:', formCode)));
    }
    getDependentFormInfo() {
        this.apiService.getDependentFormInfo(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            var _a, _b, _c, _d;
            try {
                if (this.inputData.getTaskType === 'I485' || response.data.generateFormFor) {
                    this.dependentFormInfo = response.data;
                }
                else {
                    this.dependentFormInfo = response.data;
                    const primaryApplicant = this.inputData.immigrationClassification && this.inputData.immigrationClassification === "AFFDVTSUPT864" ? (this.dependentFormInfo.primaryApplicantList).find(item => item.primaryApplicant) : this.dependentFormInfo.primaryApplicantList ? (this.dependentFormInfo.primaryApplicantList).find(item => item.primaryApplicant) : (this.dependentFormInfo.applicantList).find(item => item.primaryApplicant);
                    const secondaryApplicant = (this.dependentFormInfo.applicantList).filter(item => !item.primaryApplicant);
                    const secondaryApplicantNameList = secondaryApplicant.map(function (ele) {
                        return {
                            applicantName: ele.firstName ? `${ele.firstName} ${ele.lastName}` : null, applicantId: ele.id, isGenerated: true, isUploaded: false, relationshipCode: ele.relationshipCode, relationshipName: ele.relationshipName
                        };
                    });
                    this.formDataArray.common = this.dependentFormInfo.formTypes.common;
                    if (this.dependentFormInfo.formTypes && ((_b = (_a = this.dependentFormInfo.formTypes) === null || _a === void 0 ? void 0 : _a.primary) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                        this.formDataArray.primary = this.dependentFormInfo.formTypes.primary.map(function (ele) {
                            return Object.assign(Object.assign({}, ele), { applicantName: (primaryApplicant === null || primaryApplicant === void 0 ? void 0 : primaryApplicant.firstName) ? `${primaryApplicant === null || primaryApplicant === void 0 ? void 0 : primaryApplicant.firstName} ${primaryApplicant === null || primaryApplicant === void 0 ? void 0 : primaryApplicant.lastName}` : null, applicantId: primaryApplicant === null || primaryApplicant === void 0 ? void 0 : primaryApplicant.id, isGenerated: true, isUploaded: false, relationshipCode: primaryApplicant === null || primaryApplicant === void 0 ? void 0 : primaryApplicant.relationshipCode, relationshipName: primaryApplicant === null || primaryApplicant === void 0 ? void 0 : primaryApplicant.relationshipName });
                        });
                    }
                    if (this.dependentFormInfo.formTypes && ((_d = (_c = this.dependentFormInfo.formTypes) === null || _c === void 0 ? void 0 : _c.secondary) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                        this.formDataArray.secondary = this.dependentFormInfo.formTypes.secondary.map(function (ele) {
                            return Object.assign(Object.assign({}, ele), { secondaryApplicantNameList: secondaryApplicantNameList });
                        });
                    }
                }
            }
            catch (error) {
                console.log("error outside", error);
            }
        });
    }
    toggleMenu(item, i, event) {
        event.stopPropagation(); // Prevent the click from bubbling up to the document
        this.currentItem = i;
        this.isMenuVisible = !this.isMenuVisible;
    }
    onUploadHandle(event, fubauto, pbSupportDocumentId, formCode) {
        debugger;
        const file = event.files[0];
        file.fileName = event.files[0].name;
        if (file.size / 1024 / 1024 > this.maxfileSizeInMB) {
            CustomErrorToastComponent.showErrorToast(this.toastr, `File size should be less than or equal to ${this.maxfileSizeInMB}MB`);
            fubauto.clear();
            return;
        }
        const payload = new FormData();
        payload.append('file', file, file.name);
        let formTypeValue;
        if (formCode == 'I140' || formCode == 'I130') {
            formTypeValue = formCode;
        }
        else {
            formTypeValue = null;
        }
        this.apiService.uploadDocument(pbSupportDocumentId, payload, this.signatureDetailId, formCode).pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.toastr.success(response.message, 'Success');
            this.onReturnForms(this.returnForms);
            fubauto.clear();
        });
    }
    download(file) {
        this.apiService.downloadDocuments(environment.docs + file.substring(23), file.substring(23));
    }
    ngOnDestroy() {
        document.removeEventListener('click', this.onDocumentClick.bind(this));
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        // Update the Step Status state to empty state
        this.store.dispatch(updateStepStatusToInitialState());
    }
}
BasePrintPetitionLibraryService.ɵfac = function BasePrintPetitionLibraryService_Factory(t) { return new (t || BasePrintPetitionLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(APIPrintPetition), i0.ɵɵinject(i3.ToastrService), i0.ɵɵinject(i4.StepStatusUpdatePayloadService), i0.ɵɵinject(i5.MatDialog), i0.ɵɵinject(i6.FormBuilder)); };
BasePrintPetitionLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BasePrintPetitionLibraryService, factory: BasePrintPetitionLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BasePrintPetitionLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.Store }, { type: APIPrintPetition }, { type: i3.ToastrService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.MatDialog }, { type: i6.FormBuilder }]; }, { createtemplatelibraryheaderupload: [{
            type: ViewChild,
            args: ["createtemplatelibraryheaderupload"]
        }], createtemplatelibraryheaderkendoeditor: [{
            type: Output
        }, {
            type: ViewChild,
            args: ["createtemplatelibraryheaderkendoeditor"]
        }] }); })();

/*
 * Public API Surface of base-print-petition-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APIPrintPetition, BasePrintPetitionLibraryService };
//# sourceMappingURL=base-print-petition-library.js.map
